 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		51: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"component---docs-404-mdx","2":"component---docs-about-mdx","3":"component---docs-advanced-api-mdx","4":"component---docs-advanced-ast-mdx","5":"component---docs-advanced-components-mdx","6":"component---docs-advanced-contributing-mdx","7":"component---docs-advanced-custom-loader-mdx","8":"component---docs-advanced-index-mdx","9":"component---docs-advanced-plugins-mdx","10":"component---docs-advanced-retext-plugins-mdx","11":"component---docs-advanced-runtime-mdx","12":"component---docs-advanced-specification-mdx","13":"component---docs-advanced-sync-api-mdx","14":"component---docs-advanced-transform-content-mdx","15":"component---docs-advanced-typescript-mdx","16":"component---docs-advanced-writing-a-plugin-mdx","17":"component---docs-blog-custom-pragma-mdx","18":"component---docs-blog-index-mdx","19":"component---docs-blog-shortcodes-mdx","20":"component---docs-blog-v-1-mdx","21":"component---docs-contributing-mdx","22":"component---docs-editor-plugins-mdx","23":"component---docs-editors-mdx","24":"component---docs-getting-started-babel-config-mdx","25":"component---docs-getting-started-create-react-app-mdx","26":"component---docs-getting-started-gatsby-mdx","27":"component---docs-getting-started-index-mdx","28":"component---docs-getting-started-next-mdx","29":"component---docs-getting-started-parcel-mdx","30":"component---docs-getting-started-react-static-mdx","31":"component---docs-getting-started-typescript-mdx","32":"component---docs-getting-started-webpack-mdx","33":"component---docs-getting-started-x-0-mdx","34":"component---docs-getting-started-zero-mdx","35":"component---docs-guides-custom-loader-mdx","36":"component---docs-guides-index-mdx","37":"component---docs-guides-live-code-mdx","38":"component---docs-guides-syntax-highlighting-mdx","39":"component---docs-guides-table-of-contents-mdx","40":"component---docs-guides-terminal-mdx","41":"component---docs-guides-vue-mdx","42":"component---docs-guides-wrapper-customization-mdx","43":"component---docs-guides-writing-a-plugin-mdx","44":"component---docs-index-mdx","45":"component---docs-migrating-v-1-mdx","46":"component---docs-plugins-mdx","47":"component---docs-projects-mdx","48":"component---docs-support-mdx","49":"component---docs-syntax-mdx","50":"component---packages-gatsby-theme-mdx-src-pages-playground-mdx"}[chunkId]||chunkId) + "-" + {"1":"b9cf3a7b28609927bbb0","2":"19f166de3ae97cc94181","3":"13f4f94b4d5a581b3e12","4":"0856f4aef3baff530fca","5":"6cb063380f2b70b6cce3","6":"d589ea29ebfe88b62b1d","7":"ca85969fd3a726e298fd","8":"b10a6ed65b61f40db8af","9":"a2200910e0f6039b5454","10":"b47f0b10f6011d8a5b18","11":"d4c9bf501fd95c4761e5","12":"b57dd05d15b78ed32a54","13":"79ef084b9e9f3c50f9ab","14":"b401e14ed5476376bb64","15":"e549d703394abf8c0bcf","16":"cc609adbcd3551bd52d1","17":"b8eb64854ea3e1ac35f1","18":"61d2e75f138a491e0ca2","19":"f4749a824887794027ce","20":"36630d3b737c2104a300","21":"d25da8b6f28f814b2912","22":"ca46afcb16e55c0b6875","23":"dc71c9c1b839c105e0bd","24":"540c74e08649422b4de6","25":"e60ea92192dff6874ef4","26":"e82327e9cb765bf6bbb5","27":"81315397d540c211fb60","28":"e8cb77ccb5a07b37bafe","29":"18d1dbf14335ccb33373","30":"1023e1c931558f975222","31":"d881ae2226385197d355","32":"78a6523c57f57b9dba7c","33":"5c5997a8617b1f973da7","34":"086aadc70fe954f36b89","35":"b6f5ab85ef90e4e9af54","36":"3ec44ca02a54ba620704","37":"9a54b280ce2a1e6aa692","38":"fce6de91f9b6b9abb300","39":"1f386cab29431456b362","40":"d3833614edfe6923539f","41":"213ff9568dec83e910fe","42":"65e84b16bdeb5c1b4e78","43":"027fd94a4f57cc058588","44":"46179281843f91e4caa5","45":"035d378ff6986f62b7a7","46":"8d0905d1062800f02a92","47":"d31a9db0975c126457cc","48":"453f455db59e6f210a98","49":"0616f2adeb6aef59bc59","50":"481bb5064cda60672067","52":"db189166b95bb5fd6b2d","53":"adab86480d86db364601"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
